import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Sample data for development
const SAMPLE_GRADES = {
  grades: [
    {
      subject: "Mathematics",
      assessment: "Midterm Exam",
      score: 85,
      grade: "B",
      credits: 4,
      academicYear: "2023-2024",
      term: "Fall",
    },
    {
      subject: "Computer Science",
      assessment: "Programming Project",
      score: 92,
      grade: "A",
      credits: 3,
      academicYear: "2023-2024",
      term: "Fall",
    },
    {
      subject: "Physics",
      assessment: "Lab Report",
      score: 78,
      grade: "C",
      credits: 3,
      academicYear: "2023-2024",
      term: "Fall",
    },
    {
      subject: "English Literature",
      assessment: "Essay",
      score: 88,
      grade: "B",
      credits: 2,
      academicYear: "2023-2024",
      term: "Fall",
    },
    {
      subject: "History",
      assessment: "Research Paper",
      score: 95,
      grade: "A",
      credits: 3,
      academicYear: "2023-2024",
      term: "Fall",
    },
    {
      subject: "Chemistry",
      assessment: "Final Exam",
      score: 82,
      grade: "B",
      credits: 4,
      academicYear: "2023-2024",
      term: "Fall",
    },
  ],
  summary: {
    gpa: 3.45,
    cgpa: 3.67,
    totalCredits: 19,
    completedCredits: 15,
  },
};

export const fetchStudentGrades = createAsyncThunk(
  "grades/fetchStudentGrades",
  async (_, { rejectWithValue, getState }) => {
    try {
      // For development, return sample data
      return [];

      // Uncomment the following for actual API call when ready
      /*
      const { auth } = getState();
      const token = auth.user?.token;

      if (!token) {
        throw new Error('No authentication token available');
      }

      const response = await fetch(`${API_BASE_URL}/api/Student/Grades`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Failed to fetch grades');
      }

      return await response.json();
      */
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const gradesSlice = createSlice({
  name: "grades",
  initialState: {
    grades: [],
    summary: {
      gpa: null,
      cgpa: null,
      totalCredits: 0,
      completedCredits: 0,
    },
    loading: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStudentGrades.pending, (state) => {
        state.loading = "loading";
      })
      .addCase(fetchStudentGrades.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.grades = action.payload.grades || [];
        state.summary = action.payload.summary || {
          gpa: null,
          cgpa: null,
          totalCredits: 0,
          completedCredits: 0,
        };
      })
      .addCase(fetchStudentGrades.rejected, (state, action) => {
        state.loading = "failed";
        state.error = action.payload;
      });
  },
});

export default gradesSlice.reducer;
